import PHASES from "./phases";

export default value => {
    const data = PHASES.find((i) => i.value === value);

    return data ? data.text : "N/A";
}
